import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BookingComponent } from './payment/components/booking/booking.component';
import {ReactiveFormsModule} from '@angular/forms';
import { HomeComponent } from './payment/components/home/home.component';

@NgModule({
  declarations: [
    AppComponent,
    BookingComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
